import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'

const firebaseConfig = {
  apiKey: "AIzaSyA4dk01ppmVxSo-_VZZCFLfdiQOH5FEZpM",
  authDomain: "codeway-shared.firebaseapp.com",
  databaseURL: "https://codeway-shared.firebaseio.com",
  projectId: "codeway-shared",
  storageBucket: "codeway-shared.appspot.com",
  messagingSenderId: "821633703997",
  appId: "1:821633703997:web:86081c0263ef1f4b564a54",
  measurementId: "G-Y3CKWJZWRL"
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("setUser", user);
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
